import {FC} from 'react'

import {getSpecimenGuideContent} from '@/content/specimenGuide'
import {useTranslation} from '@/i18n'
import {routeTo} from '@/utils/router'
import {SpecimenGuideSectorMetadata} from '@/utils/specimen-guide/types'

import {CardListLayout} from '../common/cards/CardListLayout'
import {CardWrapper} from '../common/cards/CardWrapper'
import {ContentCard} from '../common/content/ContentCard'

type SpecimenGuidePopularSectorsProps = {
  title?: string
  popularSectors: SpecimenGuideSectorMetadata[]
}

export const SpecimenGuidePopularSectors: FC<SpecimenGuidePopularSectorsProps> = ({
  title,
  popularSectors,
}) => {
  const {t} = useTranslation()
  const {otherPopularSectorsTitle} = getSpecimenGuideContent()

  return (
    <>
      <CardListLayout title={title || t(otherPopularSectorsTitle)} isCentered={false}>
        {popularSectors.map(({slug, name, icon}) => (
          <CardWrapper key={name} numOfCardsPerRow={4}>
            <ContentCard
              imageSrc={icon}
              imageAlt={`${name} icon`}
              title={name}
              linkHref={routeTo.specimenGuide.sector(slug)}
              trackedEvent={{
                name: `Popular sector is clicked`,
                parameters: {sector: name},
              }}
            />
          </CardWrapper>
        ))}
      </CardListLayout>
    </>
  )
}
